import React from 'react';
import { View, Text, TextInput } from 'react-native';
import { Input, Button } from 'react-native-elements';
import { Formik } from 'formik';
import { styles } from 'styles/forms/verificationCodeForm';
import VerificationCodeFormProps from 'types/forms/VerificationCodeFormProps';
import codeValidationSchema from './schemas/verificationCodeForm';
import useMediumScreen from 'hooks/useMediumScreen';
import { useTranslation } from 'react-i18next';

export default ({ onCancel, onConfirm, generalColor }: VerificationCodeFormProps): JSX.Element => {
  const mediumScreen = useMediumScreen();

  const { t } = useTranslation();

  return (
    <Formik
      validationSchema={codeValidationSchema}
      initialValues={{ code: undefined }}
      onSubmit={(values) => onConfirm(values.code)}
    >
      {({ handleChange, handleBlur, handleSubmit, values, errors, isValid, touched }) => (
        <>
          {mediumScreen ? (
            <Input
              placeholder={t('code')}
              onChangeText={handleChange('code')}
              onBlur={handleBlur('code')}
              inputContainerStyle={[styles.inputContainer, { borderColor: generalColor }]}
              inputStyle={styles.input}
              value={values.code}
              placeholderTextColor="#979797"
              keyboardType="numeric"
            />
          ) : (
            <TextInput
              placeholder={t('code')}
              onChangeText={handleChange('code')}
              onBlur={handleBlur('code')}
              style={[styles.inputTextContainer, { borderColor: generalColor }]}
              value={values.code}
              placeholderTextColor="#979797"
              keyboardType="numeric"
            />
          )}
          {errors.code && touched.code && <Text style={styles.errorText}>{errors.code}</Text>}
          <View style={styles.modalBtnContainer}>
            <Button
              title={t('accept-upper')}
              onPress={() => handleSubmit()}
              buttonStyle={mediumScreen ? styles.confirmBtnStyle : [styles.confirmBtnStyle, styles.fullHeight]}
              titleStyle={[styles.confirmBtnText, { color: generalColor }]}
              disabled={!isValid}
            />
            <Button
              title={t('cancel-upper')}
              onPress={onCancel}
              buttonStyle={mediumScreen ? styles.cancelBtnStyle : [styles.cancelBtnStyle, styles.fullHeight]}
              titleStyle={[styles.cancelBtnText, { color: generalColor }]}
            />
          </View>
        </>
      )}
    </Formik>
  );
};
